import { Pricing } from '../types/pricing';


export enum DefaultKeys {
  NO_PRICE = 'no-price',
  ALL_COUNTRIES = 'all-countries'
}

export interface FieldPricing {
  [price: string]: {
    [country: string]: string[]
  }
}

export interface PricePerRegion {
  setupFee: string;
  merchantDiscountRate: FieldPricing
  transactionFee: FieldPricing;
  payouts: FieldPricing;
  creditFee: FieldPricing;
  chargebackHandlingFee: FieldPricing;
  rollingReserve: FieldPricing;
}

export const groupByKey = (key: string, arr: any[]): { [key: string]: any } =>
  arr.reduce((acc, obj) => {
    const property = obj[key];
    acc[property] = acc[property] || [];
    acc[property].push(obj);
    return acc;
  }, {} as { [key: string]: any });

export const buildFieldData = (field: string, arr: any[]) => {
  const result: { [key: string]: any } = {};

  const rates = groupByKey(field, arr);

  for (const rate in rates) {
    const countries = groupByKey('country', rates[rate]);

    result[rate || DefaultKeys.NO_PRICE] = {};

    for (const country in countries) {
      const paymentMethods = groupByKey('paymentMethod', countries[country]);

      result[rate || DefaultKeys.NO_PRICE][country || DefaultKeys.ALL_COUNTRIES] = Object.keys(paymentMethods);
    }
  }

  return result;
};

export const buildRegionPricing = (pricing: Pricing[], setupFee: string = '200 EU'): PricePerRegion => {
  const merchantDiscountRate = buildFieldData('merchantDiscountRate', pricing);
  const transactionFee = buildFieldData('transactionFee', pricing);
  const payouts = buildFieldData('payouts', pricing);
  const creditFee = buildFieldData('creditFee', pricing);
  const chargebackHandlingFee = buildFieldData('chargebackHandlingFee', pricing);
  const rollingReserve = buildFieldData('rollingReserve', pricing);

  return ({
    setupFee,
    merchantDiscountRate,
    transactionFee,
    payouts,
    creditFee,
    chargebackHandlingFee,
    rollingReserve,
  });
};